import React from 'react';
import PropTypes from 'prop-types';

const RICH_TEXT_STYLES = [
  '[&_ul]:list-disc [&_ul]:pl-5',
  '[&_ol]:list-decimal [&_ol]:pl-5',
  '[&_li]:my-0.5',
  '[&_a]:text-customBlue [&_a]:underline [&_a]:break-words',
  '[&_strong]:font-semibold',
  '[&_em]:italic',
  '[&_u]:underline',
  '[&_p]:mb-2 [&_p:last-child]:mb-0',
  '[&_p:empty]:min-h-[1em]',
].join(' ');

export function getPlainTextLength(html) {
  if (!html) return 0;
  return html.replace(/<[^>]*>/g, '').length;
}

function normalizeAnchors(html) {
  if (!html) return '';
  return html.replace(/<a\b([^>]*)>/gi, (_, attrs) => {
    let next = attrs;
    if (!/\btarget\s*=/i.test(next)) next += ' target="_blank"';
    if (!/\brel\s*=/i.test(next)) next += ' rel="noopener noreferrer"';
    return `<a${next}>`;
  });
}

function handleAnchorClick(e) {
  if (e.target.closest && e.target.closest('a')) {
    e.stopPropagation();
  }
}

function RichTextContent({ html, className = '' }) {
  return (
    <div
      className={`${RICH_TEXT_STYLES} ${className}`}
      onClick={handleAnchorClick}
      role="presentation"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: normalizeAnchors(html) }}
    />
  );
}

RichTextContent.propTypes = {
  html: PropTypes.string,
  className: PropTypes.string,
};

export default RichTextContent;
